export default {
  primary      : '#1973e8',
  // Colors
  black        : '#000000',
  bobBlack     : '#212121',
  transparent  : 'rgba(0,0,0,0)',
  white        : '#ffffff',
  green        : '#036B3F',
  grey         : '#666666',
  lightGrey    : '#c5c1c1',
  blue         : '#009dc1',
  orange       : '#e86b3f',
  orangeLight  : '#FF9800',
  red          : '#b00320',
  error        : '#b00320',
  warning      : '#e86b3f',
  // Material ui copy
  muiPurple    : '#9c27b0',
  muiGrey      : '#aaaaaa',
  muiBorderGrey: '#d2d2d2',
  muiText      : '#495057',
};
